import React from "react";

import { QueryClient, QueryClientProvider } from "react-query";
import { Route, Switch } from "react-router-dom";

import { _basePath } from "./config";
import { useUser } from "./context";
import { IdleTimer } from "./common/IdleTimer";

import Barcode from "./pages/Barcode";
import CreateAppointment from "./pages/CreateAppointment";
import SelectUser from "./pages/SelectUser";
import Welcome from "./pages/Welcome";

export const LOCK_DURATION_SECONDS = 300;

export const IDLE_TIMERS = {
  SELECT_USER: 30,
  CHECKIN: 30,
  EVENT_NAV: 60,
  RULES: 60,
  CONFIRMATION: 20,
};

function App() {
  const { user, users, search, loggedIn } = useUser();
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: process.env.NODE_ENV === "production" ? 3 : 0,
      },
    },
  });
  return (
    <QueryClientProvider client={queryClient}>
      <Switch>
        <Route exact path={`${_basePath}/`}>
          <Barcode />
        </Route>
        <Route exact path={`${_basePath}/select`}>
          <IdleTimer idleTimerSecs={IDLE_TIMERS.SELECT_USER} />
          <SelectUser options={users} value={search} />
        </Route>
        <Route exact path={`${_basePath}/welcome`}>
          <Welcome user={user} loggedIn={loggedIn} />
        </Route>
        <Route path={`${_basePath}/appointment`}>
          <CreateAppointment />
        </Route>
      </Switch>
    </QueryClientProvider>
  );
}

export default App;
